export function OrganizationTabSkeleton() {
    return (
        <div className="flex flex-col gap-8 pt-14">
            <div className="flex flex-col gap-6 max-w-lg">
                <div className="flex flex-col gap-1">
                    <div className="h-3 w-32 skeleton-item rounded" />
                    <div className="h-4 w-48 skeleton-item rounded mt-1" />
                </div>
                <div className="flex flex-col gap-1">
                    <div className="h-3 w-16 skeleton-item rounded" />
                    <div className="flex items-center gap-3 mt-1">
                        <div className="h-10 w-10 skeleton-item rounded" />
                        <div className="h-3 w-64 skeleton-item rounded" />
                    </div>
                </div>
            </div>

            <div className="border-t border-grey-600" />

            <div className="flex flex-col gap-4">
                <div className="h-4 w-48 skeleton-item rounded" />
                <div
                    className="grid gap-4"
                    style={{
                        gridTemplateColumns:
                            'repeat(auto-fit, minmax(200px, 1fr))',
                    }}
                >
                    {[1, 2, 3, 4].map((i) => (
                        <div
                            key={i}
                            className="skeleton-item-container border border-grey-600 rounded-[10px] p-4 flex flex-col gap-3"
                        >
                            <div className="h-4 w-20 skeleton-item rounded" />
                            <div className="h-7 w-16 skeleton-item rounded" />
                            <div className="h-3 w-24 skeleton-item rounded" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
